module.exports = __webpack_public_path__ + "static/media/VSCode_Icon.3f981acd.png";